export function resolveProviderButtonLabel(
  label: string,
  providerName: string
) {
  if (label.includes(providerName)) {
    return label.split(providerName)[0]?.trim() || label;
  }

  return label;
}
